import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import throttle from 'lodash.throttle'
import { useSelector } from 'react-redux'

import Arrow from '../navigation-arrow'
import styles from './account-nav-button.css'
import { E2E_SELECTORS } from '../../../e2e-selectors'
import { useProfile } from '../../../hooks/use-profile'

/**
 * AccountNavButton is responsible for rendering the clickable avatar button
 * in the top-right navigation menu for authenticated users.
 * It displays the current user's profile avatar and name, along with a dropdown arrow
 * that indicates whether the account menu is expanded or collapsed.
 */
function AccountNavButton({
  onClick,
  onRegisterAccountNavigationLink
}) {
  const { currentProfile, loading: currentProfileLoading, error: currentProfileError } = useProfile()

  if (currentProfileLoading || currentProfileError) {
    return null
  }

  const userName = currentProfile?.name ?? ''
  const avatar = currentProfile?.avatar?.uri ?? ''

  const menuActive = useSelector((state) => state.navigation.accountNav)

  return (
    <div
      className={classnames(styles.accountNavButton, {
        [styles.active]: menuActive
      })}
      id="navigation-account-nav-button"
      onClick={throttle((evt) => {
        evt.stopPropagation()
        onClick(menuActive)
      }, 250)}
      ref={onRegisterAccountNavigationLink}
    >
      <img alt="Avatar" src={avatar} className={styles.avatar} />
      <span
        className={styles.userName}
        data-e2e={E2E_SELECTORS.ADULT_AVATAR_MENU}
      >
        {userName}
      </span>
      <Arrow className={styles.navArrow} isExpanded={menuActive} />
      <div className={styles.menuBackground} data-lbx-e2e={userName} />
    </div>
  )
}

AccountNavButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  onRegisterAccountNavigationLink: PropTypes.func.isRequired
}

export default AccountNavButton
